import React, { type ReactNode, useEffect, useCallback } from 'react';
import Button from '@atlaskit/button/standard-button';
import { Box, Text, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import {
	useAnalyticsEvents,
	fireScreenAnalytics,
	fireUIAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import { DATA_PRIVACY_LINK } from '../constants.tsx';
import { messages } from '../messages.tsx';

const AdControlsReasonsModal = (): React.JSX.Element => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { formatMessage } = useIntl();

	useEffect(() => {
		fireScreenAnalytics(createAnalyticsEvent({}));
	}, [createAnalyticsEvent]);

	const clickedLinkBaseEvent = createAnalyticsEvent({
		action: 'clicked',
		actionSubject: 'link',
		attributes: {
			buttonName: 'adControlsPrivacyPolicy',
			teamName: 'galileo',
			experimentName: 'discover_ideas_in_issue_view',
		},
	});

	const onPrivacyPolicyClick = useCallback(() => {
		fireUIAnalytics(clickedLinkBaseEvent, 'adControlsPrivacyPolicy');
	}, [clickedLinkBaseEvent]);

	return (
		<>
			{formatMessage(messages.reasonsModalExplanation, {
				strong: (chunks: ReactNode[]) => <Text as="strong">{chunks}</Text>,
			})}
			<Box xcss={styledBullet}>
				<ul>
					<li>{formatMessage(messages.reasonsModalBulletOne)}</li>
					<li>{formatMessage(messages.reasonsModalBulletTwo)}</li>
				</ul>
			</Box>
			<Button
				appearance="link"
				spacing="none"
				href={DATA_PRIVACY_LINK}
				target="_blank"
				onClick={onPrivacyPolicyClick}
				interactionName="auto-generated.issue-view-jpd-ideas.ui.crossflow-idea-card.ad-controls.button"
			>
				{formatMessage(messages.privacyPolicy)}
			</Button>
		</>
	);
};

export default AdControlsReasonsModal;

const styledBullet = xcss({
	marginBottom: 'space.150',
});
